import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => FormSelectComponent),
  multi: true,
};

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.sass'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class FormSelectComponent
  implements AfterViewInit, OnInit, OnChanges, ControlValueAccessor {
  errors: any;
  @Input() messageError: string;
  @Input() options: any[];
  @Input() label: string;
  @Input() optionDescription: string;
  @Input() optionValue: string;
  @Input() placeholder: string;
  @Input() prefix: string;
  @Input() type = 'text';
  @Input() width: string;
  @Input() disabled = false;
  @Input() hasError = true;
  @ViewChild('input') input: ElementRef;
  @ViewChild('input') select: MatSelect;

  @Output() $onChange: EventEmitter<any> = new EventEmitter();

  innerValue: any = '';

  constructor() {}

  ngAfterViewInit() {
    (this.select as any)._getItemHeight = () => this.select._triggerFontSize;
  }

  ngOnInit() {}

  ngOnChanges(simple: SimpleChanges) {
    // if (!simple.options || simple.options.currentValue.length === 0) {
    //   return;
    // }
    // if (this.innerValue) {
    //   return;
    // }
    // this.innerValue = simple.options.currentValue[0][this.optionValue];
    // this.propagateChange(this.innerValue);
    // this.$onChange.emit({value: this.innerValue});
  }

  onChange(e: any) {
    this.innerValue = e.value;
    this.propagateChange(this.innerValue);
    this.$onChange.emit(e);
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
    }
  }

  propagateChange = (_: any) => {};

  writeValue(value: any) {
    this.innerValue = value;
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}
}
